module.exports = "/hub/_next/static/assets/dbfa302a454bf504b51e95cee93d4b74.svg";